import { validateUser } from 'data/api';
import { isEmailValid, isFullNameValid, isLoginValid } from 'libs/validators';

const validateAsync = async (field, value) => {
  const response = await validateUser({
    user: {
      [field]: value
    }
  });

  if ('errors' in response) {
    var _response$errors$find, _response$errors$find2;

    return (_response$errors$find = (_response$errors$find2 = response.errors.find(error => error.field === field)) === null || _response$errors$find2 === void 0 ? void 0 : _response$errors$find2.value) !== null && _response$errors$find !== void 0 ? _response$errors$find : true;
  }

  return true;
};

export const validateRealName = value => isFullNameValid(value) && validateAsync('real_name', value);
export const validateEmail = value => isEmailValid(value) && validateAsync('email', value);
export const validateLogin = value => isLoginValid(value) && validateAsync('login', value);
export const validatePassword = value => validateAsync('password', value);